import * as Yup from 'yup';
import { occupationSchema } from '../occupationOptions';
export const addProperty = Yup.object().shape({
  rent: Yup.string()
    .required('Rent Amount is required')
    .test(
      'is-greater-than-minimum',
      'Rent amount must be at least $100',
      (value) => parseFloat(value) >= 100
    )
    .test('has-max-two-decimals', 'Rent amount cannot have more than two decimal places', (value) =>
      /^\d+(\.\d{0,2})?$/.test(value)
    )
    .test(
      'is-less-than-max',
      'Rent amount must be less than 1000000',
      (value) => parseFloat(value) < 1000000
    )
    .typeError('Rent Amount must be a valid number'),

  dueDay: Yup.number()
    .min(1, 'Select a day between 1 and 28')
    .max(28, 'Select a day between 1 and 28')
    .required('Monthly due date is required'),
  occupation: occupationSchema,
});
